import { render, staticRenderFns } from "./DetailOther.vue?vue&type=template&id=61e68ad3&scoped=true"
import script from "./DetailOther.vue?vue&type=script&lang=js"
export * from "./DetailOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e68ad3",
  null
  
)

export default component.exports